import {
  REGISTER_ARTIST,
  REGISTER_ARTIST_SUCCESSFUL,
  REGISTER_ARTIST_FAILED,
  SET_COUNTRIES,
  USER_SUBSCRIBE,
  USER_SUBSCRIBE_FAILED,
  USER_SUBSCRIBE_SUCCESSFUL,
  GETTOP_ARTIST,
  GETMYTOP_ARTIST_SUCCESSFUL,
  GETTOP_ARTIST_FAILED,
  NEWSLETTER,
  NEWSLETTER_FAILED,
  NEWSLETTER_SUCCESSFUL,
} from "./actionTypes";


const initialState = {
  registrationError: null,
  message: null,
  loading: false,
  subscriptionError: null,
  newsLetterError: null,
  topArtist: [],
  countries: [],
  totaltopArtist: {},
};

const account = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_ARTIST:
      return {
        ...state,
        user: null,
        loading: true,
        registrationError: null,
      };

    case REGISTER_ARTIST_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        user: action.payload,
        registrationError: null,
      };

    case REGISTER_ARTIST_FAILED:
      return {
        ...state,
        user: null,
        loading: false,
        registrationError: action.payload,
      };
      case SET_COUNTRIES:
        return { ...state, countries: action.payload };

    case USER_SUBSCRIBE:
      return {
        ...state,
        user: null,
        loading: true,
        subscriptionError: null,
      };

    case USER_SUBSCRIBE_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        user: action.payload,
        subscriptionError: null,
      };

    case USER_SUBSCRIBE_FAILED:
      return {
        ...state,
        user: null,
        loading: false,
        subscriptionError: action.payload,
      };

    //  News Letter

    case NEWSLETTER:
      return {
        ...state,
        user: null,
        loading: true,
        newsLetterError: null,
      };

    case NEWSLETTER_FAILED:
      return {
        ...state,
        user: null,
        loading: false,
        newsLetterError: action.payload,
      };

    case NEWSLETTER_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        user: action.payload,
        newsLetterError: null,
      };

    //  Top Artist User

    case GETTOP_ARTIST:
      return {
        ...state,
        loading: true,
      };

    case GETMYTOP_ARTIST_SUCCESSFUL:
      return {
        ...state,
        topArtist: action.payload.data || [],
        totaltopArtist: action.payload.totalCount || 0,
        loading: false,
        error: "",
      };
    case GETTOP_ARTIST_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default account;
